import { createContext, useContext, useState } from 'react';
import { ContextProviderProps, Unit } from './interfaces';

interface AuthUser {
    id: number,
    units: Unit[],
    firstName: string,
    lastName: string,
    isDoctor: boolean,
    isAdmin?: boolean,
    isSuperAdmin?: boolean,
    isExpenseUnitAdmin?: boolean,
    isSupportAdmin?: boolean,
    doctorUniqueIdCode: string | null,
};

interface UserContextType {
    user: AuthUser | null,
    setUser: (val: AuthUser | null) => void;
};

export const UserContext = createContext({} as UserContextType);
export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = ({ children }: ContextProviderProps) => {
    const [user, setUser] = useState<AuthUser | null>(null);
    return <UserContext.Provider value={{ user, setUser }}>
        {children}
    </UserContext.Provider>
};